<template>
    <div class="page list-integrations">
        <h2 class="d-none d-lg-inline">Integrations</h2>

        <ul class="integration-list">
            <li v-for="(integration, index) in integrations" v-bind:key="index" class="row integration">
                <div class="col-6">
                    <h4>{{ integration.type }}</h4>
                </div>
                <div class="col-6">
                    <div class="integration-toggle">
                        <span><template v-if="!integration.active">Off</template></span>
                        <i v-if="integration.active" v-on:click="confirmToggleIntegration(index)" class="fas fa-toggle-on toggle toggle--on"></i>
                        <i v-if="!integration.active" v-on:click="confirmToggleIntegration(index)" class="fas fa-toggle-off toggle toggle--off"></i>
                        <span><template v-if="integration.active">On</template></span>
                    </div>
                </div>


                    <div class="col-12 mt-3">
                        <h6>Queued Updates</h6>
                        <ul class="integration__updates-list">
                            <li class="header">
                                <div>Created</div>
                                <div>Guest</div>
                                <div>Arrival</div>
                                <div class="update-type">Type</div>
                                <div>LastUpdated</div>
                                <div class="update-type"><i class="fa-solid fa-triangle-exclamation"></i></div>
                                <div class="update-type"></div>
                            </li>
                            <template v-if="integration.loadingQueuedUpdates">
                                <div class="col-12 mt-3 text-center">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="integration.queuedUpdates && integration.queuedUpdates.length === 0">
                                    <li>
                                        <div class="col-12 mt-3 text-center">
                                            <div>No updates</div>
                                        </div>
                                    </li>
                                </template>
                                <template v-else>
                                    <li v-for="(update, index) in integration.queuedUpdates" v-bind:key="index" v-bind:class="{ 'text-error': update.processingError }">
                                        <div>{{ friendlyDateAndTimeFullISO(update.created) }}</div>
                                        <div>{{ update.guest }}</div>
                                        <div>{{ friendlyDate(update.arrival) }}</div>
                                        <div class="update-type">{{ update.updateType }}</div>
                                        <div>{{ friendlyDateAndTime(update.entityLastUpdated) }}</div>
                                        <div class="update-type">
                                            <div v-if="update.processingError" class="text-error">
                                                <span class="tooltip-container">
                                                    <i v-on:mouseenter="showTooltipForErrorMessage(update.reference)" v-on:mouseleave="hideTooltipForErrorMessage()" class="fa-solid fa-triangle-exclamation"></i>
                                                    <tooltip v-bind:visible="referenceForTooltipErrorMessage === update.reference" v-bind:position="'bottom'" v-bind:text="update.errorMessage" class="text-error"></tooltip>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="update-type"><button v-if="update.processingError" class="btn btn-secondary" v-on:click.stop="retry(integration, update.reference)">Retry</button></div>
                                    </li>
                                </template>
                            </template>
                        </ul>
                    </div>

                    <div class="col-12 mt-3"> 
                        <h6>Processed Updates</h6>
                        <ul class="integration__updates-list">
                            <li class="header">
                                <div>Created</div>
                                <div>Guest</div>
                                <div>Arrival</div>
                                <div class="update-type">Type</div>
                                <div>Processed</div>
                            </li>
                            <template v-if="integration.loadingProcessedUpdates">
                                <div class="col-12 mt-3 text-center">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <li v-for="(update, index) in integration.processedUpdates" v-bind:key="index">
                                    <div>{{ friendlyDateAndTime(update.entityFirstUpdated) }}</div>
                                    <div>{{ update.guest }}</div>
                                    <div>{{ friendlyDate(update.arrival) }}</div>
                                    <div class="update-type">{{ update.updateType }}</div>
                                    <div>{{ friendlyDateAndTime(update.processed) }}</div>
                                </li>
                            </template>
                        </ul>
                    </div>

            </li>
        </ul>

        <confirm-dialog v-bind:message="'Are you sure you want to toggle this integration?'"
                        v-bind:callbackPrimaryName="'toggle-integration'"
                        v-bind:callbackPrimaryReference="'' + currentIndex"
                        v-if="showConfirmToggleDialog"/>

    </div>
</template>

<script>
    import Vue from 'vue';
    import { store } from '../store.js'

    import Tooltip from '../components/Tooltip.vue'
    import ConfirmDialog from '../components/ConfirmDialog.vue'

    import {datesMixin} from "../mixins/DatesMixin"

    export default {
        name: 'ListIntegrations',
        components: {ConfirmDialog, Tooltip },
        mixins: [datesMixin],
        data() {
            return {
                loading: false,
                integrations: [
                    {
                        name: 'Breezeway',
                        active: false,
                        queuedUpdates: [
                            {
                                created: 'Mar 14 @ 14:41',
                                guest: 'Doe',
                                arrival: '2021-01-01',
                                error: true,
                                lastUpdated: 'Mar 14 @ 14:41'
                            }
                        ],
                        processedUpdates: [
                            {
                                created: 'Mar 14 @ 14:41',
                                guest: 'Doe',
                                arrival: '2021-01-01',
                                processed: 'Mar 14 @ 14:41'
                            }
                        ]
                    }
                ],
                currentIndex: null,
                showConfirmToggleDialog: false,
                referenceForTooltipErrorMessage: null
            };
        },
        computed: {
        },
        methods: {
            fetchIntegrations: async function () {
                this.loading = true;
                try {
                    const response = await this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/integrations', {
                        withCredentials: true
                    });
                    console.log(response);
                    if (response.data) {
                        this.integrations = response.data;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false;
                }
            },
            loadUpdatesForIntegrations: function () {
                console.log("fetching updates");
                for (let integration of this.integrations) {
                    console.log("fetching updates for " + integration.type);
                    this.fetchQueuedUpdates(integration);
                    this.fetchProcessedUpdates(integration);
                }
            },
            fetchQueuedUpdates: async function (integration) {
                Vue.set(integration, 'loadingQueuedUpdates', true);
                try {
                    const response = await this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/integrations/' + integration.type + '/queued-updates', {
                        withCredentials: true
                    });
                    console.log(response);
                    if (response.data) {
                        const index = this.integrations.findIndex(i => i.type === integration.type);
                        if (index !== -1) {
                            Vue.set(this.integrations[index], 'queuedUpdates', response.data);
                        }
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    integration.loadingQueuedUpdates = false;
                }
            },
            fetchProcessedUpdates: async function (integration) {
                Vue.set(integration, 'loadingProcessedUpdates', true);
                try {
                    const response = await this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/integrations/' + integration.type + '/processed-updates', {
                        withCredentials: true
                    });
                    console.log(response);
                    if (response.data) {
                        const index = this.integrations.findIndex(i => i.type === integration.type);
                        if (index !== -1) {
                            Vue.set(this.integrations[index], 'processedUpdates', response.data);
                        }
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    integration.loadingProcessedUpdates = false;
                }
            },
            showTooltipForErrorMessage: function(updateReference) {
                this.referenceForTooltipErrorMessage = updateReference;
            },
            hideTooltipForErrorMessage: function() {
                this.referenceForTooltipErrorMessage = null;
            },
            retry: async function(integration, updateReference) {
                console.log("Retrying update " + updateReference);
                try {
                    const response = await this.$http.post('/guest-management/v1/companies/' + store.host.company.reference + '/integrations/' + integration.type + '/queued-updates/' + updateReference + "/retry", {
                        withCredentials: true
                    });
                    console.log(response);
                    if (response.data) {
                        const queuedUpdates = integration.queuedUpdates || [];
                        const index = queuedUpdates.findIndex(qu => qu.reference === updateReference);
                        console.log("index: " + index);
                        if (index !== -1) {
                            Vue.set(queuedUpdates, index, response.data);
                        }
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    integration.loadingQueuedUpdates = false;
                }            },
            confirmToggleIntegration: function(index) {
                this.currentIndex = index;
                this.showConfirmToggleDialog = true;
            },
            toggleIntegration: async function(index) {
                this.showConfirmToggleDialog = false;
                if (this.currentIndex !== parseInt(index)) {
                    return;
                }
                let body = {
                    turnOn: !this.integrations[this.currentIndex].active
                }
                try {
                    await this.$http.put('/guest-management/v1/companies/' + store.host.company.reference + '/integrations/' + this.integrations[this.currentIndex].reference + '/toggle', 
                                        body);
                    this.integrations[this.currentIndex].active = !this.integrations[this.currentIndex].active;
                    this.infoMessage = "Integration turned " + ((this.integrations[this.currentIndex].active) ? "on" : "off");
                    setTimeout(() => {
                        this.updating = false;
                    }, 2000);
                } catch (error) {
                    console.log(error);
                }
            }
        },
        mounted: async function() {
            await this.fetchIntegrations();
            this.loadUpdatesForIntegrations();
            
            this.$root.$on('toggle-integration', this.toggleIntegration);
        },
        beforeDestroy() {
            this.$root.$off('toggle-integration', this.toggleIntegration);        
        }
    };
</script>

<style lang="scss" scoped>
  @import "../styles/pages/_list_integrations.scss";
  @import "../styles/layout/_toggle.scss";
</style>
